module.exports = __webpack_public_path__ + "img/document.7ea2fed2.png";